import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Sidebar from "../../Components/Sidebar/Sidebar";
import LabelHeader from "../../Components/Commons/LabelHeader";
import TextField from "../../Components/Commons/Forms/TextField";
import PasswordField from "../../Components/Commons/Forms/PasswordField";
import SelectField from "../../Components/Commons/Forms/SelectField";
import BtnSave from "../../Components/Commons/Buttons/BtnSave";
import { Row, Col, Tabs, Tab } from "react-bootstrap";
import {
  editUser,
  editPassword,
  getUserID,
} from "../../Components/Helpers/API/UserApi/UserApi";
import "./Users.css";
import { validateUser, validatePassword } from "../../Components/Helpers/Utilities/Validations/Validations";
import { toast } from "react-toastify";
function EditUsers() {
  const navigate = useNavigate();
  const { id, tab } = useParams();
  const [selectedTab, setSelectedTab] = useState(tab);
  const [isClicked, setIsClicked] = useState(false);
  const [userData, setUserData] = useState({
    username: "",
    full_name: "",
    role_name: "",
    password: "",
    confirm_password: "",
  });
  
 const role = [
    {
      key: "0",
      value: "",
      label: "Select",
    },
    {
      key: "1",
      value: "director",
      label: "Director",
    },
    {
      key: "2",
      value: "pcp",
      label: "PCP",
    },
        {
      key: "3",
      value: "specialist",
      label: "Specialist",
    },
    {
      key: "4",
      value: "nurse",
      label: "nurse",
    },
    {
      key: "5",
      value: "resident",
      label: "Resident",
    },
    {
      key: "6",
      value: "laboratory",
      label: "Laboratory",
    },
  ];
  const [isError, setError] = useState({
    username: false,
    password: false,
    confirm_password: false,
    full_name: false,
    role: false,
  });
  async function handleSubmit() {
    setIsClicked(true);
    if (validateUser(userData, setError) && !isClicked) {
      const response = await editUser(userData);
      if (response.data) {
        toast.success(response.data.message);
        setTimeout(() => {
          navigate("/users");
        }, 1000);
      } else if (response.error) {
        response.error.data.messages.error_messages.forEach((errMsg) => {
          toast.error(errMsg);
        });
      }
    }
    setIsClicked(false);
  }
  async function handlePassword() {
    setIsClicked(true);
    if (validatePassword(userData, setError) && !isClicked) {
      if (userData.password === userData.confirm_password) {
        const response = await editPassword(userData);
        if (response.data) {
          toast.success(response.data.message);
          setTimeout(() => {
            navigate("/users");
          }, 1000);
        } else if (response.error) {
          response.error.data.messages.error_messages.forEach((errMsg) => {
            toast.error(errMsg);
          });
        }
      } else {
        toast.error("Password and Confirm Password is not the same.");
      }
    }
    setIsClicked(false);
  }
  const handleSelectRole = (event) => {
    const selectedValue = event.target.value;
    const selectedOption = role.find(
      (option) => option.value === selectedValue
    );

    if (selectedOption) {
      const { key, value } = selectedOption;
      setUserData((prev) => ({ ...prev, role_id: key, role_name: value }));
    }
  };
  const handleChange = (e) => {
    const { name, value } = e.target;
    setUserData((prev) => ({ ...prev, [name]: value }));
  };
  async function fetchUserData() {
    try {
      const response = await getUserID(id);
      if (response.data) {
        const user = response.data[0]
        setUserData((prev) => ({
          ...prev,
          full_name: user.full_name,
          id: user.id,
          role_id: user.role_id,
          role_name: user.role_name,
          username: user.username
        }));
      } else {
        setUserData([]);
      }
    } catch (error) {}
  }

  useEffect(() => {
    fetchUserData();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  return (
    <div className="App">
      <Sidebar active={"Users"} />
      <div className="col p-5 add-customer pt-4">
        <LabelHeader text={"EDIT USER"} />
        <Tabs
          activeKey={selectedTab}
          id="PO-tabs"
          className="manager-tabs mt-4"
          onSelect={(e) => {
            setSelectedTab(e);
          }}
        >
          <Tab eventKey="edit-user" title="Edit User">
            <div className="pt-5">
              <div className="row mt-2">
                <div>
                  <TextField
                    required
                    id="full_name"
                    type={`inline`}
                    formLabel={`Full Name`}
                    size={`sm`}
                    value={userData ? userData.full_name : ""}
                    onChange={handleChange}
                    name="full_name"
                    isError={isError.full_name}
                    errorMessage="Full name is required"
                    disabled={isClicked}
                  />
                  <SelectField
                    required
                    type={`inline`}
                    formLabel={`Role`}
                    name="role_name"
                    size={`sm`}
                    options={role}
                    value={userData ? userData.role_name : ""}
                    isError={isError.role}
                    onChange={handleSelectRole}
                    errorMessage="Role is required"
                    // disabled={isClicked}
                    disabled
                  />
                  <TextField
                    required
                    id="username"
                    type={`inline`}
                    formLabel={`Username`}
                    size={`sm`}
                    value={userData ? userData.username : ""}
                    onChange={handleChange}
                    name="username"
                    isError={isError.username}
                    errorMessage="Username is required"
                    disabled={isClicked}
                  />
                </div>
              </div>
            </div>
            <Row className="justify-content-end mt-4">
              <Col xs={2} className="edit-save patient-manager">
                <BtnSave
                  onClick={handleSubmit}
                  label={"Submit"}
                  size={"xs"}
                  isClicked={isClicked}
                  disabled={
                    !userData ||
                    Object.values(userData.username || "").every((value) => value === "") ||
                    Object.values(userData.full_name).every((value) => value === "") ||
                    Object.values(userData.role_name).every((value) => value === "") 
                  }
                />
              </Col>
            </Row>
          </Tab>
          <Tab eventKey="reset-password" title="Reset Password">
            <div className="pt-5">
              <div className="row mt-2">
                <div>
                  <PasswordField
                    required
                    id="password"
                    type={`inline`}
                    formLabel={`Password`}
                    size={`sm`}
                    onChange={handleChange}
                    name="password"
                    isError={isError.password}
                    errorMessage="Password is required"
                    disabled={isClicked}
                  />
                </div>
                <div>
                  <PasswordField
                    required
                    id="confirm_password"
                    type={`inline`}
                    formLabel={`Confirm Password`}
                    size={`sm`}
                    onChange={handleChange}
                    name="confirm_password"
                    isError={isError.confirm_password}
                    errorMessage="Confirm password is required"
                    disabled={isClicked}
                  />
                </div>
              </div>
            </div>
            <Row className="justify-content-end mt-4">
              <Col xs={2} className="edit-save patient-manager">
                <BtnSave
                  label={"Submit"}
                  size={"xs"}
                  onClick={handlePassword}
                  isClicked={isClicked}
                  disabled={
                    !userData ||
                    Object.values(userData.confirm_password).every((value) => value === "") ||
                    Object.values(userData.password).every((value) => value === "") 
                  }
                />
              </Col>
            </Row>
          </Tab>
        </Tabs>
      </div>
    </div>
  );
}

export default EditUsers;
